module.exports = __webpack_public_path__ + "static/media/category-menu-3.2a1cab6c.webp";